import { Component } from '@angular/core';
import { PlaylistComponent } from '../../components/playlist/playlist.component';
import { Button } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { NavigatorComponent } from '../../components/navigator/navigator.component';

@Component({
  selector: 'jam',
  imports: [
    PlaylistComponent,
    NavigatorComponent,
    NavigatorComponent,
  ],
  templateUrl: './jam.component.html',
  styleUrl: './jam.component.scss',
})
export class JamComponent {}
